/* unplugin-vue-components disabled */import { render } from "./share-prompt.vue?vue&type=template&id=6effe59b&scoped=true"
import script from "./share-prompt.vue?vue&type=script&setup=true&lang=js"
export * from "./share-prompt.vue?vue&type=script&setup=true&lang=js"

import "./share-prompt.vue?vue&type=style&index=0&id=6effe59b&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6effe59b"],['__file',"src/pages/share-prompt/share-prompt.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6effe59b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6effe59b', __exports__)) {
    api.reload('6effe59b', __exports__)
  }
  
  module.hot.accept("./share-prompt.vue?vue&type=template&id=6effe59b&scoped=true", () => {
    api.rerender('6effe59b', render)
  })

}


export default __exports__